import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { mount, getSection } from "ducks/discovery";

import Sections from "apps/discovery/components/Sections";

function mapStateToProps(state) {
	return {
		sections: state.discovery.sections,
		sectionOrder: state.discovery.sectionOrder,
		showDisplayAd: state.discovery.promos.showDisplayAd,
		showJobsAd: state.discovery.promos.showJobsAd,
		isGettingQuestionMatches: state.discovery.isGettingQuestionMatches,
		isGettingInterestMatches: state.discovery.isGettingInterestMatches,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			mount,
			getSection,
		},
		dispatch
	);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Sections);



// WEBPACK FOOTER //
// ./src/apps/discovery/containers/Sections.jsx